<template>
  <Modal2 :modalId="modalId" ref="modal2">
    <div class="mdl-body-l">
      <div
        class="mdl-body-xs">
        <p>
          ブラウザの「戻る」ボタンはご利用できません。
        </p>
      </div><!-- end .mdl-body -->
    </div>
  </Modal2>
</template>

<script>
/* 準標準ライブラリ */
/* 定数 */
/* コンポーネント */
import { CrossIcon, SendIcon } from "icons";
import Modal2 from "./Modal2.vue";

export default {
  name: "CancelBrowserBackModal",
  props: {
    modalId: {
      type: String,
      default: "",
    },
  },
  components: {
    Modal2,
  },
  data() {
    return {
      icons: {
        CrossIcon,
        SendIcon,
      },
    };
  },
  methods: {
    async openModal() {
      /* 初期化処理 */
      try {
        this.$refs.modal2.openModal();
      } catch (err) {
        console.log(err);
        this.setErrorNotification({
          message: "予期せぬエラーが発生しました。",
        });
      }
    },
  },
};
</script>
